import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import '../styles/layout.css';

const MainLayout = ({ children }) => {
  return (
    <div className="app-root">
      <Header />
      <main className="app-main">{children}</main>
      <Footer />
    </div>
  );
};

export default MainLayout;

